import React, { useContext, useEffect, useState } from 'react';

import { api } from 'fr-shared/api';
import { Breadcrumb, Button, Helmet } from 'fr-shared/components';
import { AlertContext } from 'fr-shared/context';

const PendingUsers = () => {
  const { setAlert } = useContext(AlertContext);
  const [users, setUsers] = useState([]);
  const [approvingUserId, setApprovingUserId] = useState(null);
  const [denyingUserId, setDenyingUserId] = useState(null);

  const fetchUsers = () => {
    api
      .get('/pending_users')
      .then(res => {
        setUsers(res.data);
      })
      .catch(() => {
        setAlert({
          message: 'Failed to load pending users. Please refresh and try again.',
          color: 'danger',
        });
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchUsers(), []);

  const handleApproveUser = user => {
    setApprovingUserId(user.id);

    api
      .patch(`/pending_users/${user.id}/approve`)
      .then(() => {
        setAlert({ message: `${user.email} approved.`, color: 'success' });
        setUsers(current => current.filter(u => u.id !== user.id));
      })
      .catch(() => {
        setAlert({
          message: 'An unexpected error occurred. Please refresh and try again.',
          color: 'danger',
        });
      })
      .finally(() => setApprovingUserId(null));
  };

  const handleDenyUser = user => {
    if (!window.confirm(`Are you sure you want to deny ${user.email}?`)) {
      return;
    }

    setDenyingUserId(user.id);

    api
      .delete(`/pending_users/${user.id}`)
      .then(() => {
        setAlert({ message: `${user.email} denied.`, color: 'success' });
        setUsers(current => current.filter(u => u.id !== user.id));
      })
      .catch(() => {
        setAlert({
          message: 'An unexpected error occurred. Please refresh and try again.',
          color: 'danger',
        });
      })
      .finally(() => setDenyingUserId(null));
  };

  return (
    <>
      <Helmet title="Pending Users" />
      <Breadcrumb to="/admin/domains">Pending Users</Breadcrumb>

      <div className="page-header">
        <div className="container">
          <h2>Pending Users</h2>
        </div>
      </div>
      <div className="container">
        <table className="table bg-white">
          <thead>
            <tr>
              <th>Email</th>
              <th>Organization</th>
              <th>Signed up</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 && (
              <tr>
                <td colSpan={4}>No users awaiting approval.</td>
              </tr>
            )}
            {users.map(user => (
              <tr key={user.id}>
                <td>{user.email}</td>
                <td>{user.organization_name}</td>
                <td>{user.inserted_at}</td>
                <td className="text-right">
                  <Button
                    size="sm"
                    loading={approvingUserId === user.id}
                    onClick={() => handleApproveUser(user)}
                  >
                    Approve
                  </Button>
                  <Button
                    size="sm"
                    color="danger"
                    outline
                    className="ml-2"
                    loading={denyingUserId === user.id}
                    onClick={() => handleDenyUser(user)}
                  >
                    Deny
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PendingUsers;
